import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "button" };
const _hoisted_2 = {
    key: 0,
    class: "icon"
};
const _hoisted_3 = { key: 0 };
export default /*#__PURE__*/ _defineComponent({
    __name: 'Button',
    props: {
        icon: {},
        text: {},
        busy: { type: Boolean, default: false }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon");
            return (_openBlock(), _createElementBlock("button", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                    (_ctx.icon !== undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                            (_ctx.icon !== undefined)
                                ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                                    key: 0,
                                    icon: _ctx.icon,
                                    "beat-fade": _ctx.busy
                                }, null, 8, ["icon", "beat-fade"]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (_ctx.text !== undefined)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.text), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
